package ru.villawonka.app.presentation.screens.splash.viewmodel

import kotlinx.coroutines.delay
import ru.villawonka.app.common.mvvm.BaseViewModel
import ru.villawonka.app.common.utils.fold
import ru.villawonka.app.domain.model.PostTypeDomain
import ru.villawonka.app.domain.model.SearchParamsDomain
import ru.villawonka.app.domain.usecase.GetUserSettingsUseCase
import ru.villawonka.app.domain.usecase.IsNewUserUseCase
import ru.villawonka.app.platform.platform.Platform
import ru.villawonka.app.platform.platform.model.PlatformType
import ru.villawonka.app.resources.AppResources

class SplashViewModel(
    private val startParam: String?,
    private val platform: Platform,
    private val appResources: AppResources,
    private val minLoadingTimeMs: Long = 1000L,
    private val getUserSettingsUseCase: GetUserSettingsUseCase,
    private val isNewUserUseCase: IsNewUserUseCase,
) : BaseViewModel<SplashUIState>() {

    init {
        loadScreen()
    }

    override fun createInitialState() = SplashUIState.Loading

    fun onRetryButtonClick() = launch { loadScreen() }

    private fun loadScreen() = launch {
        setState(SplashUIState.Loading)
        delay(minLoadingTimeMs)
        getUserSettingsUseCase().fold(
            ifLeft = { setState(SplashUIState.Error(it)) },
            ifRight = {
                appResources.setLanguage(it.language)
                handleDeeplink(startParam, isNewUserUseCase())
            }
        )
    }

    private suspend fun handleDeeplink(startParam: String?, isFirstLaunch: Boolean) {
        try {
            val event = when (platform.type) {
                PlatformType.TELEGRAM -> parseTelegramStartParam(startParam, isFirstLaunch)
                PlatformType.IOS, PlatformType.ANDROID -> parseMobileStartParam(startParam, isFirstLaunch)
            }
            shootEvent(event ?: defaultEvent(isFirstLaunch))
        } catch (e: Exception) {
            shootEvent(defaultEvent(isFirstLaunch))
        }
    }


    private fun parseTelegramStartParam(param: String?, isFirstLaunch: Boolean): SplashUIEvent? {
        if (param.isNullOrBlank()) return null

        return try {
            val (key, value) = param.split("_").let {
                it.first() to it.last()
            }

            when (key) {
                "accommodation" -> value.toIntOrNull()?.let { postId ->
                    SplashUIEvent.OpenPostCardScreen(
                        isNeedSetupScreenShow = isFirstLaunch,
                        postId = postId,
                        postType = PostTypeDomain.ACCOMMODATION
                    )
                }
                "transport" -> value.toIntOrNull()?.let { postId ->
                    SplashUIEvent.OpenPostCardScreen(
                        isNeedSetupScreenShow = isFirstLaunch,
                        postId = postId,
                        postType = PostTypeDomain.TRANSPORT
                    )
                }
                "search" -> SearchParamsDomain.fromBase64(value)?.let { searchParams ->
                    SplashUIEvent.OpenSearchScreen(
                        isNeedSetupScreenShow = isFirstLaunch,
                        searchParamsDomain = searchParams
                    )
                }
                else -> null
            }
        } catch (e: Exception) {
            null
        }
    }

    private fun parseMobileStartParam(startParam: String?, isFirstLaunch: Boolean): SplashUIEvent {
        // TODO: Реализовать логику для мобильных платформ
        return defaultEvent(isFirstLaunch)
    }

    private fun defaultEvent(isFirstLaunch: Boolean) = SplashUIEvent.OpenSearchScreen(
        isNeedSetupScreenShow = isFirstLaunch,
        searchParamsDomain = SearchParamsDomain.RentalItem.Accommodation()
    )
}